module.exports = __webpack_public_path__ + "static/media/thumb-down-outline-blue.30b65b14.svg";